import {
  DashboardRoundedIcon,
  ApartmentRoundedIcon,
  CreditScoreRoundedIcon,
  VisibilityRoundedIcon,
  PeopleAltRoundedIcon,
  DirectionsWalkRoundedIcon,
  EventAvailableRoundedIcon,
  SummarizeRoundedIcon,
  AssignmentTurnedInRoundedIcon,
  FactCheckRoundedIcon,
  HistoryRoundedIcon,
  LockRoundedIcon,
  BarChartRoundedIcon,
  SwapVertRoundedIcon
} from "../icons";

export const MENU_ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: DashboardRoundedIcon, href: "/" },
  { key: "condo-units", label: "Condo Units", icon: ApartmentRoundedIcon, href: "/condo-units" },
  { key: "condo-payment", label: "Condo Payment", icon: CreditScoreRoundedIcon, href: "/condo-payment" },
  { key: "view-occupancy", label: "View Condo Occupancy", icon: VisibilityRoundedIcon, href: "/view-occupancy" },
  { key: "stay-in-employees", label: "Overall Stay-in Employees", icon: PeopleAltRoundedIcon, href: "/stay-in-employees" },
  { key: "stay-out-history", label: "Staff Stay-out History", icon: DirectionsWalkRoundedIcon, href: "/stay-out-history" },
  { key: "stay-in-history", label: "Staff Stay-in History", icon: EventAvailableRoundedIcon, href: "/stay-in-history" },
  { key: "payment-summary", label: "Condo Unit Payment Summary", icon: SummarizeRoundedIcon, href: "/payment-summary" },
  { key: "submit-rf", label: "Submit Condo RF", icon: AssignmentTurnedInRoundedIcon, href: "/submit-rf" },
  { key: "monthly-headcount", label: "Monthly HeadCount", icon: FactCheckRoundedIcon, href: "/monthly-headcount" },
  { key: "rf-history", label: "Condo RF History", icon: HistoryRoundedIcon, href: "/rf-history" },
  { key: "lock-period", label: "Payment Lock Period Setting", icon: LockRoundedIcon, href: "/lock-period" },
  { key: "expense-summary", label: "Overall Condo Unit Expense Summary", icon: BarChartRoundedIcon, href: "/expense-summary" },
  { key: "dorm-movement", label: "Dorm Movement", icon: SwapVertRoundedIcon, href: "/dorm-movement" }
];
